import React, { Component, Fragment } from 'react';
import moment from "moment/moment";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import NumberFormat from 'react-number-format';
import { toast } from "react-toastify";

import LYCompensation from "./LYCompensation";
import { last } from 'lodash';


export default class UpdatedDashboard extends Component {

    state = {
        showLYCompensation: false,
        showCombined: false,
        enableAddButton: true,
        enableEditButton: true,
        showRevenue: true,
        showAddPlProfileRow: false,
        startDate: "",
        endDate: "",
        isRevenueChanged: false,
    }

    addAndEditPlProfile = (flag) => {
        let enableAddButton, enableEditButton, startDate, endDate;
        if (flag) {
            enableAddButton = true;
            enableEditButton = false;
            startDate = moment().startOf('month');
            endDate = moment(startDate).add(1, 'years').subtract(1, 'day');
        } else {
            if (this.props.plListProfile) {
                enableAddButton = false,
                    enableEditButton = true,
                    // startDate = this.props.plProfile.start_date,
                    startDate = moment(this.props.plProfile.start_date).startOf('day'),
                    endDate = moment(this.props.plProfile.end_date).startOf('day');
            } else {
                return false;
            }
        }

        this.setState({
            startDate,
            endDate,
            enableAddButton,
            enableEditButton,
            showAddPlProfileRow: true,
            showRevenue: false
        });

        this.props.handleStartEndDateChange(startDate, endDate);
    };

    savePlProfile = () => {
        this.props.savePlProfile(this.state.enableAddButton);
        this.setState({
            enableAddButton: true,
            enableEditButton: true,
            showAddPlProfileRow: false,
            showRevenue: true
        });
    };

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    };

    handleStartDateChange = async (date) => {
        let startDate = moment(date).startOf('month');
        let { endDate } = this.state;
        let minDate = moment(date.add(1, "days"));
        let maxDate = moment(date.add(12, "months").subtract(2, "days"));
        if (!(endDate >= minDate && endDate <= maxDate)) {
            await this.setState({ endDate: maxDate }, () => this.props.handleDateChange(this.state.endDate, "end_date"));
        }

        this.setState({ startDate: startDate }, () => this.props.handleDateChange(startDate, "start_date"));
    };

    handleStartEndChange = (date) => {
        let endDate = moment(date).startOf('day');
        if (date > this.state.startDate) {
            this.setState({ endDate: endDate }, () => this.props.handleDateChange(date, "end_date"));
        }
    };

    handleChange = (elementClass, values) => {
        let elClass = elementClass.split('-');
        const { floatValue } = values;
        this.setState({ isRevenueChanged: true });
        this.props.handleRevenueChange(elClass, parseInt(floatValue, 10))
    };

    saveRevenue = () => {
        this.setState({ isRevenueChanged: false });
        this.props.saveRevenue(true);
    };

    cancelRevenueChanges = () => {
        this.setState({ isRevenueChanged: false });
        this.props.cancelRevenueChanges();
    };

    // Cancel add/edit profile dates changes
    cancelChange = () => {
        this.setState({
            showRevenue: true,
            showAddPlProfileRow: false,
            enableAddButton: true,
            enableEditButton: true
        });

        this.props.cancelPlListChange();
    };

    getLYCompensation = () => {
        if (this.props.plListProfile) {
            this.setState({ showLYCompensation: true });
        } else {
            toast.error("Please select P&L Profile.");
        }
    };

    cancelLYCompensation = () => {
        this.setState({ showLYCompensation: false })
    };

    backToDashboard = async () => {
        this.setState({
            showAddPlProfileRow: false
        });

        if (this.state.isRevenueChanged) {
            this.props.showConfirmModal({
                msgTitle: 'Save / Discard Changes !',
                msgBody: [
                    <p>There are some unsaved changes in Revenue Actual.</p>,
                    <p>Do you want to save / discard the changes ?</p>
                ],
                buttons: [
                    {
                        label: 'Save',
                        onClick: () => {
                            this.saveRevenue();
                            this.props.backToDashboard();
                        },
                        className: 'btn-success'
                    },
                    {
                        label: 'Discard',
                        onClick: () => {
                            this.props.backToDashboard();
                        },
                        className: 'btn-danger'
                    },
                    {
                        label: 'Cancel',
                        onClick: () => { },
                        className: 'btn-primary'
                    }
                ]
            });
        } else {
            this.props.backToDashboard();
        }
    };

    openEditGoals = () => {
        if (this.state.isRevenueChanged) {
            this.props.showConfirmModal({
                msgTitle: 'Save / Discard Changes !',
                msgBody: [
                    <p>There are some unsaved changes in Revenue Actual.</p>,
                    <p>Do you want to save / discard the changes ?</p>
                ],
                buttons: [
                    {
                        label: 'Save',
                        onClick: () => {
                            this.saveRevenue();
                            this.props.getRevenueGoal();
                        },
                        className: 'btn-success'
                    },
                    {
                        label: 'Discard',
                        onClick: () => {
                            this.props.getRevenueGoal();
                        },
                        className: 'btn-danger'
                    },
                    {
                        label: 'Cancel',
                        onClick: () => { },
                        className: 'btn-primary'
                    }
                ]
            });
        } else {
            this.props.getRevenueGoal();
        }
    };

    openOverrideGoal = () => {
        if (this.state.isRevenueChanged) {
            this.props.showConfirmModal({
                msgTitle: 'Save / Discard Changes !',
                msgBody: [<p>There are some unsaved changes in Revenue Actual.</p>,
                <p>Do you want to save / discard the changes ?</p>
                ],
                buttons: [
                    {
                        label: 'Save',
                        onClick: () => {
                            this.saveRevenue();
                            this.props.getOverrideGoal();
                        },
                        className: 'btn-success'
                    },
                    {
                        label: 'Discard',
                        onClick: () => {
                            this.props.getOverrideGoal();
                        },
                        className: 'btn-danger'
                    },
                    {
                        label: 'Cancel',
                        onClick: () => { },
                        className: 'btn-primary'
                    }
                ]
            });
        } else {
            this.props.getOverrideGoal();
        }
    };

    render = () => {
        const {
            enableEditButton, enableAddButton, showAddPlProfileRow, startDate, endDate,
            showRevenue, showLYCompensation
        } = this.state;

        const {
            plList, plProfile, plListProfile, totalLYRevenue,
            totalTYRevenue, revenues, iw
        } = this.props;
        const today = moment().subtract(1, "month");
        // const lastyear = moment(today).subtract(24, "month");
        let islastPeriodEditable = true
        const profileEndDate = plProfile && plProfile.end_date ? moment(plProfile.end_date) : today;
        const isOldProfile = profileEndDate < today;
        if (revenues.length == 1){
            islastPeriodEditable = false;
        }
        
        let plListOption;
        let topRevenueRow = [], bottomRevenueRow = [],
            topNewRevenueRow = [], bottomNewRevenueRow = [],
            topTableHeader = [], bottomTableHeader = [],
            topCombinedRevenueRow = [], bottomCombinedRevenueRow = [],
            topTotal = [], bottomTotal = [];

        if (typeof plList !== "undefined" && plList.length) {
            plListOption = plList.map((list) =>
                <option key={list.id} value={list.id}>{list.profile}</option>
            );

            if (typeof plProfile !== 'undefined' &&
                typeof revenues !== 'undefined' && revenues.length > 0
            ) {
                topTableHeader.push(<th key={-3}>Month</th>);
                topNewRevenueRow.push(<td key={-3}>New</td>);
                topRevenueRow.push(<td key={-3}>Renewal</td>);
                topCombinedRevenueRow.push(<td key={-3}>Revenue</td>);
                topTotal.push(<td className="text-nowrap" key={-3}>Last Period</td>);
                bottomTableHeader.push(<th key={-3}>Month</th>);
                bottomNewRevenueRow.push(<td key={-3}>New</td>);
                bottomRevenueRow.push(<td key={-3}>Renewal</td>);
                bottomCombinedRevenueRow.push(<td key={-3}>Revenue</td>);
                bottomTotal.push(<td className="text-nowrap" key={-3}>Last Period</td>);
                revenues.map((revenue, index) => {
                    if (6 > index) {
                        topTableHeader.push(
                            <th className="text-center" key={"month-" + revenue.id}>
                                <span className="revenue-block">{revenue.month_name}</span>
                            </th>
                        );

                        topNewRevenueRow.push(
                            <td className={"newrevenue-" + revenue.id}
                                key={"newrevenue-" + revenue.id}
                            >
                                <NumberFormat type="tel" value={revenue.new_revenue}
                                    thousandSeparator={true} prefix={'$ '} allowNegative={false}
                                    onValueChange={(values) => this.handleChange(
                                        "newrevenue-" + revenue.id, values)}
                                    className="form-control  form-control-sm text-center"
                                    name="new_revenue" tabIndex={index * 2 + 1}
                                    disabled={false}
                                />
                            </td>
                        );
                        topRevenueRow.push(
                            <td className={"revenue-" + revenue.id}
                                key={"revenue-" + revenue.id}
                            >
                                <NumberFormat type="tel" value={revenue.renewal_revenue}
                                    thousandSeparator={true} prefix={'$ '}
                                    allowNegative={false}
                                    onValueChange={(values) => this.handleChange(
                                        "revenue-" + revenue.id, values)}
                                    className="form-control form-control-sm text-center"
                                    name="renewal_revenue" tabIndex={(index + 1) * 2}
                                    disabled={false}
                                />
                            </td>
                        );
                        topCombinedRevenueRow.push(
                            <td className={"combined-" + revenue.id}
                                key={"combined-" + revenue.id}
                            >
                                <NumberFormat type="tel" value={revenue.combined_revenue}
                                    thousandSeparator={true} prefix={'$ '} allowNegative={false}
                                    onValueChange={(values) => this.handleChange(
                                        "combined-" + revenue.id, values)}
                                    className="form-control form-control-sm text-center"
                                    name="combined_revenue" tabIndex={(index + 1)}
                                    disabled={false}
                                />
                            </td>
                        );
                        topTotal.push(
                            <td key={"lyrevenue-" + revenue.id}>
                                <NumberFormat type="tel" value={revenue.last_year_revenue}
                                    thousandSeparator={true} prefix={'$ '} allowNegative={false}
                                    onValueChange={(values) => this.handleChange(
                                        "lyrevenue-" + revenue.id, values)}
                                    className="form-control form-control-sm text-center"
                                    name="last_year_revenue" tabIndex={index + 30}
                                    disabled={islastPeriodEditable}
                                />
                            </td>
                        );
                    } else {
                        bottomTableHeader.push(
                            <th className="text-center" key={"month-" + revenue.id}>
                                <span className="revenue-block">{revenue.month_name}</span>
                            </th>
                        );
                        bottomNewRevenueRow.push(
                            <td className={"newrevenue-" + revenue.id}
                                key={"newrevenue-" + revenue.id}
                            >
                                <NumberFormat type="tel" value={revenue.new_revenue}
                                    thousandSeparator={true} prefix={'$ '}
                                    allowNegative={false}
                                    onValueChange={(values) => this.handleChange(
                                        "newrevenue-" + revenue.id, values)}
                                    className="form-control  form-control-sm text-center"
                                    name="new_revenue" tabIndex={(index + 1) * 2}
                                    disabled={false}
                                />
                            </td>
                        );
                        bottomRevenueRow.push(
                            <td className={"revenue-" + revenue.id}
                                key={"revenue-" + revenue.id}
                            >
                                <NumberFormat type="tel" value={revenue.renewal_revenue}
                                    thousandSeparator={true} prefix={'$ '}
                                    allowNegative={false}
                                    onValueChange={(values) => this.handleChange(
                                        "revenue-" + revenue.id, values)}
                                    className="form-control form-control-sm text-center"
                                    name="renewal_revenue" tabIndex={(index + 1) * 2}
                                    disabled={false}
                                />
                            </td>
                        );
                        bottomCombinedRevenueRow.push(
                            <td className={"combined-" + revenue.id}
                                key={"combined-" + revenue.id}
                            >
                                <NumberFormat type="tel" value={revenue.combined_revenue}
                                    thousandSeparator={true} prefix={'$ '}
                                    allowNegative={false}
                                    onValueChange={(values) => this.handleChange(
                                        "combined-" + revenue.id, values)}
                                    className="form-control form-control-sm text-center"
                                    name="combined_revenue" tabIndex={(index + 1)}
                                    disabled={false}
                                />
                            </td>
                        );
                        bottomTotal.push(
                            <td key={"lyrevenue-" + revenue.id}>
                                <NumberFormat type="tel"
                                    value={revenue.last_year_revenue}
                                    thousandSeparator={true} prefix={'$ '}
                                    allowNegative={false}
                                    onValueChange={
                                        (values) => this.handleChange(
                                            "lyrevenue-" + revenue.id, values)}
                                    className="form-control form-control-sm text-center"
                                    name="last_year_revenue" tabIndex={index + 30}
                                    disabled={islastPeriodEditable}
                                />
                            </td>
                        );
                    }

                    return true;

                });
            }
        }

        return (
            <section className="container-fluid p-0">
                <div className="clearfix"></div>
                <div className={`card ${iw ? 'card-section' : 'border'}`}>
                    <div className={`card-header py-2 ${iw ? 'text-white' : 'bg-light'}`}>
                        <ul className="secondary-menu">
                            {showLYCompensation || iw ? '' :
                                <li className="pl-0" onClick={this.backToDashboard}>
                                    <a className="pl-0"> Back</a>
                                </li>
                            }
                            {iw ? null :
                                <li onClick={this.openEditGoals}>
                                    <a> Edit Goals</a>
                                </li>
                            }
                            <li onClick={this.openOverrideGoal}>
                                <a>
                                    {iw ? "Revenue" : "Override"} Goals
                                </a>
                            </li>
                            {iw ?
                                <i className="fa fa-info-circle text-white"
                                    title="Revenue Goal is calculated based on the planned retention and growth for the soft rollout period."
                                ></i> : null
                            }
                            {!iw &&
                                <li onClick={this.getLYCompensation}>
                                    <a> LY Compensation Paid</a>
                                </li>
                            }
                        </ul>
                    </div>
                    <div className="card-body bg-f5">
                        {showLYCompensation &&
                            <LYCompensation
                                cancelLYCompensation={this.cancelLYCompensation}
                                plListProfile={plListProfile}
                                permission={this.props.permission}
                                isOldProfile={isOldProfile}
                            />
                        }
                        {!showLYCompensation && showAddPlProfileRow && !iw ?
                            <fieldset className="card card-body pt-1">
                                <legend className="mb-0 pb-1" style={{ width: "fit-content" }}><small><small>{
                                    enableAddButton ? 'Add' : 'Edit'} Profile Date Range </small></small></legend>
                                <div className="row date-info">
                                    <div className="col-5 col-sm-3">
                                        <label className="mb-0">Start Date</label>
                                        <DatePicker
                                            selected={startDate}
                                            onChangeRaw={this.handleDateChangeRaw}
                                            onChange={this.handleStartDateChange}
                                            dateFormat="MM/DD/YYYY"
                                            fixedHeight
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            className="form-control"
                                            minDate={moment('2012-01-01')}
                                            maxDate={moment().add(5, 'years')}
                                            autoComplete="off" list="autocompleteOff"
                                        />
                                    </div>
                                    <div className="col-4 col-sm-3">
                                        <label className="mb-0">End Date</label>
                                        <DatePicker
                                            selected={endDate}
                                            onChangeRaw={this.handleDateChangeRaw}
                                            onChange={this.handleStartEndChange}
                                            dateFormat="MM/DD/YYYY"
                                            fixedHeight
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            minDate={moment(this.state.startDate).add(1, 'days')}
                                            maxDate={moment(this.state.startDate).add(
                                                1, 'years').subtract(1, 'days')}
                                            className="form-control"
                                            autoComplete="off" list="autocompleteOff"
                                        />
                                    </div>
                                    <div className="col-1">
                                        <label></label><br />
                                        <button className="btn btn-success"
                                            onClick={this.savePlProfile}> Save </button>
                                    </div>
                                    <div className="col-1">
                                        <label></label><br />
                                        <button className="btn btn-warning"
                                            onClick={this.cancelChange}> Cancel </button>
                                    </div>
                                </div>
                                <div className="row date-info">
                                    <div className="col-12">
                                        Date will always start from 1st of each month.
                                    </div>
                                </div>
                            </fieldset>
                            : !showLYCompensation ?
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="row date-info">
                                            <div className="col-5">
                                                <div className="form-group">
                                                    <select
                                                        name="plList"
                                                        className="form-control"
                                                        onChange={
                                                            (event) => this.props.getSelectedPlList(event)}
                                                        value={plListProfile}>
                                                        <option value="">
                                                            Select P&L Profile
                                                        </option>
                                                        {plListOption}
                                                    </select>
                                                </div>
                                            </div>
                                            {enableAddButton && !iw ?
                                                <div className="col-3">
                                                    <button
                                                        className="btn btn-info"
                                                        onClick={() => this.addAndEditPlProfile(true)}>
                                                        <i className="fa fa-plus"></i> Add Date Range
                                                    </button>
                                                </div>
                                                : null
                                            }
                                            {plListProfile && enableEditButton && !iw ?
                                                <div className="col-3">
                                                    <button
                                                        className="btn btn-info"
                                                        onClick={() => this.addAndEditPlProfile(false)}>
                                                        <i className="fa fa-edit"></i> Edit Date Range
                                                    </button>
                                                </div>
                                                : null
                                            }
                                            {plListProfile && iw ?
                                                <div className="col-6">
                                                    <label className="bg-primary text-white py-1 px-2 font-16 width-300">
                                                        <span className="float-left">
                                                            Total LY Revenue: &nbsp;
                                                            <i className="fa fa-info-circle"
                                                                title="Total LY Revenue is the 
                                                            last year’s revenue for the 
                                                            months in the soft rollout period."
                                                            ></i>
                                                        </span>
                                                        <span className="font-18 box-text-shadow float-right font-weight-bold">
                                                            <NumberFormat value={totalLYRevenue}
                                                                displayType={'text'} decimalScale={0}
                                                                thousandSeparator={true} prefix={'$ '}
                                                                className="font-18 box-text-shadow" />
                                                        </span>
                                                    </label>
                                                </div> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        {plListProfile && !iw &&
                                            <button
                                                className={plProfile.combine_new_renewal ?
                                                    "btn btn-danger pull-r" : "btn btn-success pull-r"}
                                                onClick={() => this.props.updateCombinedRevenue()}>
                                                {
                                                    plProfile.combine_new_renewal ?
                                                        "Don't Combine New & Renewal Revenue"
                                                        :
                                                        "Combine New & Renewal Revenue"
                                                }
                                            </button>
                                        }
                                    </div>
                                </div>
                                : ""
                        }
                        {!showLYCompensation && showRevenue && plListProfile ?
                            <Fragment>
                                {iw ? null : <Fragment>
                                    <div className="card card-body bg-light rounded py-2">
                                        <table><tbody>
                                            <tr>
                                                <td className="py-2 text-nowrap">
                                                    <h5 className="mb-0">Monthly Revenue:</h5>
                                                </td>
                                                <td>
                                                    "Monthly Revenue" is the total commission
                                                    revenue from both New and Renewal business
                                                    in the current compensation period.
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="py-2 text-nowrap">
                                                    <h5 className="mb-0">Last Year Revenue:</h5>
                                                </td>
                                                <td>
                                                    "Last Year Revenue" is the amount of
                                                    commission revenue received in the
                                                    previous compensation period.
                                                </td>
                                            </tr>
                                        </tbody></table>
                                    </div>

                                    <div className="row r-calculate">
                                        <div className="col-sm-5 text-right">
                                            <label className="bg-primary text-white py-1 px-2 font-16 width-300">
                                                <span className="float-left">
                                                    Total LY Revenue:
                                                </span>
                                                <span className="font-18 box-text-shadow float-right font-weight-bold">
                                                    <NumberFormat value={totalLYRevenue}
                                                        displayType={'text'} decimalScale={0}
                                                        thousandSeparator={true} prefix={'$ '}
                                                        className="font-18 box-text-shadow"
                                                    />
                                                </span>
                                            </label>
                                        </div>
                                        <div className="col-sm-1"></div>
                                        <div className="col-sm-5">
                                            <label className="bg-score text-white py-1 px-2 font-16 width-300">
                                                <span className="float-left">
                                                    Total TY Revenue:
                                                </span>
                                                <span className="font-18 box-text-shadow float-right font-weight-bold">
                                                    <NumberFormat value={totalTYRevenue}
                                                        displayType={'text'} decimalScale={0}
                                                        thousandSeparator={true} prefix={'$ '}
                                                        className="font-18 box-text-shadow"
                                                    />
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </Fragment>
                                }
                                <div className="revenue-container">
                                    <div className="table-responsive revenue-table">
                                        <table>
                                            <thead>
                                                <tr>{topTableHeader}</tr>
                                            </thead>
                                            <tbody>
                                                {iw ? null :
                                                    plProfile.combine_new_renewal ?
                                                        <tr>{topCombinedRevenueRow}</tr> :
                                                        <Fragment>
                                                            <tr>{topNewRevenueRow}</tr>
                                                            <tr>{topRevenueRow}</tr>
                                                        </Fragment>
                                                }
                                                <tr className={iw ? "" : "border-top"}>
                                                    {topTotal}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {(typeof revenues !== "undefined" && revenues.length > 6) &&
                                        <div className="table-responsive revenue-table r-table-2">
                                            <table>
                                                <thead>
                                                    <tr>{bottomTableHeader}</tr>
                                                </thead>
                                                <tbody>
                                                    {iw ? null :
                                                        plProfile.combine_new_renewal ?
                                                            <tr>{bottomCombinedRevenueRow}</tr> :
                                                            <Fragment>
                                                                <tr>{bottomNewRevenueRow}</tr>
                                                                <tr>{bottomRevenueRow}</tr>
                                                            </Fragment>
                                                    }
                                                    <tr className={iw ? "" : "border-top"}>
                                                        {bottomTotal}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </div>
                            </Fragment>
                            : ""
                        }
                    </div>
                    {showLYCompensation || showAddPlProfileRow || !plListProfile ?
                        ""
                        :
                        <div className="card-footer text-right py-1">
                            {(
                                this.props.permission.can_add || this.props.permission.can_edit
                            ) &&
                                <button type="button" className="btn btn-success"
                                    onClick={this.saveRevenue} tabIndex={25}
                                > Save </button>
                            }
                            &nbsp;&nbsp;&nbsp;
                            <button type="button" className="btn btn-warning"
                                onClick={this.cancelRevenueChanges} tabIndex={26}
                            > Cancel </button>
                            {iw ? null : <Fragment>&nbsp;&nbsp;&nbsp;
                                <button type="button" className="btn btn-info"
                                    onClick={() => this.backToDashboard()} tabIndex={27}
                                > Back </button>
                            </Fragment>
                            }
                        </div>
                    }
                </div>
            </section>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/agencyRevenue/UpdatedDashboard.js